// extracted by mini-css-extract-plugin
export default {"root":"PlasmicLastWeekDataButton_root__X9f7L","text":"PlasmicLastWeekDataButton_text__zDOWP"};